import styled from 'styled-components';

export const StyledCar = styled.img`
  transform: rotate(${(props) => props.$degree}rad);
  position: absolute;
  top: -25px;
  left: -25px;
  transform-origin: center;
`;
